<template>
  <div @keypress="submit">
    <div   style="display: flex">
      <input style="margin-right: 10px; display: block; width: 100%" v-model="valueToSearch" />
      <button style="margin-left: 10px" @click="raiseSearch()">{{ BTNSEARCH }}</button>
      <button style="margin-left: 10px" @click="clearText()">{{ BTNCLEAR }}</button>
    </div>
    <div class="testonormalecentrato" style="margin-top: 10px;">
      {{ labelText }}
    </div>
    <div v-if="stringEmpty" class="titolorosso testocentrato" style="margin-top: 10px">
      {{ SELPAR }}
    </div>
  </div>
</template>

<script>
import { getSTRING } from '@/js/utils';

export default {
  name: "SearchComponent",
  props: ["lang", "labelText", "searchText"],
  emits: { search: null, reset: null },
  data() {
    return {
      valueToSearch: this.searchText,
      stringEmpty: false,
      SELPAR: '',
      BTNSEARCH: '',
      BTNCLEAR: ''
    };
  },
  mounted() {
    this.SELPAR = getSTRING(this.lang, "SELPAR", "Specificare il parametro di ricerca");
    this.BTNSEARCH = getSTRING(this.lang, "BTNSEARCH", "Cerca");
    this.BTNCLEAR = getSTRING(this.lang, "BTNCLEAR", "Pulisci");
  },
  methods: {
    submit(e) {
      if (e.keyCode === 13) {
         this.raiseSearch()
      }
    },
    clearText() {
      this.valueToSearch = "";
      this.stringEmpty = false;
      this.$emit("reset");
    },
    raiseSearch() {
      if (this.valueToSearch.length > 0) {
        this.stringEmpty = false;
        this.$emit("search", this.valueToSearch);
      } else {
        this.stringEmpty = true;
      }
    },
  },
};
</script>

<style scoped>
button {
  margin: 0 auto;
}
</style>